import { render, staticRenderFns } from "./statisticDays.vue?vue&type=template&id=8fa9cd74&scoped=true"
import script from "./statisticDays.vue?vue&type=script&lang=js"
export * from "./statisticDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa9cd74",
  null
  
)

export default component.exports